export const formatDate = (dateString: string | null, isHE: boolean) => {
  if (dateString === null) {
    const str = isHE ? "בקרוב" : "Coming Soon";
    return str;
  }
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are zero-indexed, so add 1
  const year = date.getFullYear() % 100; // Get the last two digits of the year
  return `${day}.${month}.${year}`;
};

export const filterByLanguage = (arr: any[], isHE: boolean): any[] => {
  if (!Array.isArray(arr)) {
    throw new Error("Input must be an array.");
  }

  return arr.filter((_, index) => (isHE ? index % 2 !== 0 : index % 2 === 0));
};

export const convertHeightToMeters = (height: string): string => {
  if (height === "N/A") {
    return "נתון לא זמין";
  }
  const [feet, inches] = height.split("'").map(Number); // Split by ' and convert to numbers
  const totalInches = feet * 12 + inches;
  const totalCentimeters = totalInches * 2.54; // 1 inch = 2.54 cm
  const totalMeters = totalCentimeters / 100; // Convert centimeters to meters

  return totalMeters.toFixed(2); // Format to 2 decimal places as a string
};

export const convertPoundsToKilograms = (pounds: number): number => {
  const kilograms = pounds * 0.453592; // 1 pound = 0.453592 kilograms
  return parseFloat(kilograms.toFixed(1)); // Rounded to 2 decimal places
};

export const translateExperienceToHeb = (term: string): string => {
  let hebTerm = "";
  switch (term) {
    case "Freshman":
      hebTerm = "פרשמן";
      break;
    case "Sophmore":
      hebTerm = "סופמור";
      break;
    case "Junior":
      hebTerm = "ג'וניור";
      break;
    case "Senior":
      hebTerm = "סניור";
      break;
    case "Super Senior":
      hebTerm = "סניור שנה חמישית";
      break;
  }
  return hebTerm;
}